import '../App.css';
import './Header.css';
import './Content.css';
import './Footer.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Pack = () => {
    return (
        <div className='App'>
      <header>
        <Navbar expand="lg" className='Header-nav'>
          <Container>
            <Navbar.Brand href="/"><img alt="TheGoldApple logo, with the name written in italics" className="d-inline-block align-top Header-logo" src="https://cdn.tga.fyi/logos/tga_logo_lang_2.png"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='Header-toggler'/>
            <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
                {/* <Nav.Link className='Header-button' href="/vacencies">Vacencies</Nav.Link> */}
                <Nav.Link className='Header-button' href="https://status.tga.fyi">Status</Nav.Link>
                <Nav.Link className='Header-button' href="https://thegoldapple.com/discords">Discord</Nav.Link>
                <Nav.Link className='Header-button' href="https://forum.tga.fyi">Forum</Nav.Link>
                <Nav.Link className='Header-button' href="ts3server://ts.thegoldapple.com">TS</Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Container>
          <Row>
            <Col className='Header-mission-statement'>
              <p><strong>TheGoldApple Pack</strong></p>
              <p>A modpack aimed towards technology.</p>
              <a href="https://www.technicpack.net/modpack/thegoldapple.1816812" className='btn Header-btn-dl'>Download</a>
            </Col>
            <Col className="Header-row-img">
              <img src="https://cdn.tga.fyi/logos/tgapack.png" alt="TGAPack Logo" width={"500rem"} />
            </Col>
          </Row>
        </Container>
        <div className='Header-fade'></div>
      </header>
      <Container className='Content'>
        <h1>About</h1>
        <h2>Server</h2>
        <p>As part of the mod pack there is a server that is hosted for the community, but to join the server you need to join the <a href="https://discord.gg/3kwXARuxNj">Discord server</a> so we can whitelist you.</p>
        <h2>Mod List</h2>
        <div className='Content-mod-list'>
          <Container>
            <Row>
              <Col>
                <ul>
                  <li>appliedenergistics2-rv6-stable-7</li>
                  <li>Backups-1.12.2-1.5.7</li>
                  <li>Baubles-1.12-1.5.2</li>
                  <li>BiblioCraft[v2.4.6][MC1.12.2]</li>
                  <li>Botania r1.10-364.4</li>
                  <li>buildcraft-all-7.99.24.8</li>
                  <li>cc-tweaked-1.12.2-1.89.2</li>
                  <li>Chisel-MC1.12.2-1.0.2.45</li>
                  <li>chiselsandbits-14.33</li>
                  <li>Clumps-3.1.2</li>
                  <li>CodeChickenLib-1.12.2-3.2.3.358-universal</li>
                  <li>CoFHCore-1.12.2-4.6.6.1-universal</li>
                  <li>CoFHWorld-1.12.2-1.4.0.1-universal</li>
                  <li>!configanytime-3.0</li>
                  <li>CTM-MC1.12.2-1.0.2.31</li>
                  <li>EnderStorage-1.12.2-2.4.6.137-universal</li>
                  <li>extrautils2-1.12-1.9.9</li>
                  <li>ExtremeReactors-1.12.2-0.4.5.68</li>
                  <li>FluxNetworks-1.12.2-4.1.1.34</li>
                  <li>forestry_1.12.2-5.8.2.387</li>
                  <li>Forgelin-1.8.4</li>
                  <li>ForgeMultipart-1.12.2-2.6.2.83-universal</li>
                  <li>furniture-6.3.2-1.12.2</li>
                  <li>Hwyla-1.8.26-B41_1.12.2</li>
                  <li>IC2Classic-1.12.2-1.5.9</li>
                  <li>ic2cuumatter-1.12.2-1.1.3</li>
                  <li>ICBM-classic-1.12.2-6.0.1</li>
                  <li>industrialforegoing-1.12.2-1.12.13-237</li>
                  <li>InventoryTweaks-1.63</li>
                  <li>ironchest-1.12.2-7.0.72.847</li>
                  <li>jei_1.12.2-4.16.1.301</li>
                  <li>journeymap-1.12.2-5.7.1p2</li>
                  <li>Mantle-1.12-1.3.3.55</li>
                </ul>
              </Col>
              <Col>
                <ul>
                  <li>Mekanism-1.12.2-9.8.3.390</li>
                  <li>MekanismGenerators-1.12.2-9.8.3.390</li>
                  <li>MekanismTools-1.12.2-9.8.3.390</li>
                  <li>!mixinbooter-8.8</li>
                  <li>MrTJPCore-1.12.2-2.1.4.43-universal</li>
                  <li>OpenBlocks-1.12.2-1.8.1</li>
                  <li>OpenModsLib-1.12.2-0.12.2</li>
                  <li>Patchouli-1.0-23.6</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-Base</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-compat</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-fabrication</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-integration</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-lighting</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-mechanical</li>
                  <li>ProjectRed-1.12.2-4.9.4.120-world</li>
                  <li>railcraft-12.0.0</li>
                  <li>randompatches-1.12.2-1.22.1.10</li>
                  <li>ReAuth-1.12-Forge-4.0.7</li>
                  <li>RebornCore-1.12.2-3.19.5-universal</li>
                  <li>RedstoneFlux-1.12-2.1.1.1-universal</li>
                  <li>StevesCarts-1.12.2-2.4.32.137</li>
                  <li>TConstruct-1.12.2-2.13.0.183</li>
                  <li>tesla-core-lib-1.12.2-1.0.18</li>
                  <li>theoneprobe-1.12-1.4.28</li>
                  <li>ThermalCultivation-1.12.2-0.3.6.1-universal</li>
                  <li>ThermalDynamics-1.12.2-2.5.6.1-universal</li>
                  <li>ThermalExpansion-1.12.2-5.5.7.1-universal</li>
                  <li>ThermalFoundation-1.12.2-2.6.7.1-universal</li>
                  <li>ThermalInnovation-1.12.2-0.3.6.1-universal</li>
                  <li>twilightforest-1.12.2-3.11.1021-universal</li>
                  <li>WR-CBE-1.12.2-2.3.2.33-universal</li>
                  <li>zerocore-1.12.2-0.1.2.9</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
     
      <Container className='Footer'>
        <Row>
          <Col>
            <p>Designed and created by <a href="https://lawrencetech.uk" className='Footer-credit'><b>Lawrence Tech</b></a>, made in the UK.</p>
            <p>Copyright (c) {(new Date().getFullYear())} TheGoldApple & Lawrence Tech All Rights Reserved.</p>
            <hr />
            <p>Made with 
              <svg width="25px" height="25px" viewBox="-10.5 -9.45 21 18.9" fill="none" xmlns="http://www.w3.org/2000/svg" className="Footer-icon"><circle cx="0" cy="0" r="2" fill="currentColor"></circle><g stroke="currentColor" stroke-width="1" fill="none"><ellipse rx="10" ry="4.5"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(60)"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(120)"></ellipse></g></svg>
            </p>
          </Col>
          <Col className='Footer-Links'>
            <h4>Links</h4>
            <div>
              <ul>
                <li><a className='Footer-Link' href="terms">Terms and Conditions</a></li>
                <li><a className='Footer-Link' href="#about">About Us</a></li>
                <li><a className='Footer-Link' href="#styleguide">Style Guide</a></li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    );
}

export default Pack;